import React, { useState, useContext, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setCheckWallet, setConfirmWallet } from "../redux/actions/app";
import { connectToMetamask } from "../apis/blockchain";
import { Web3Context } from "../contexts/Web3Context";
import { closePopup } from "../redux/actions/modal";

export default function () {
  const dispatch = useDispatch();
  const web3Context = useContext(Web3Context);

  const approveHandler = (e) => {
    e.preventDefault();
    connectWallet();
  };

  const connectWallet = async () => {
    await connectToMetamask(
      web3Context.web3.metamaskProvider,
      web3Context.isMetamaskConnected
    );
    return dispatch(closePopup());
  };

  return (
    <div className="modal modal_480 modal-wallet">
      <div className="">
        <img src="/assets/images/page-icons/connect.svg" alt="wallet" />
      </div>

      <h2
        style={{
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "30px",
          lineHeight: "37px",
          textAlign: "center",
          marginTop: "20px",
        }}
      >
        Please connect your wallet
      </h2>
      <button
        className="custom-button modal-wallet__btn"
        onClick={connectWallet}
      >
        <span>CONNECT</span>
      </button>
    </div>
  );
}
